import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from "@angular/router";
import { delay, filter, of, switchMap } from "rxjs";

@Component({
  selector: "app-navigating-indicator",
  templateUrl: "./navigating-indicator.component.html",
  styleUrls: ["./navigating-indicator.component.scss"],
  standalone: true,
  imports: [MatProgressBarModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigatingIndicatorComponent {
  private readonly router = inject(Router);

  private readonly DELAY_MS = 250;

  protected readonly isNavigating = toSignal(
    this.router.events.pipe(
      filter(
        (event) =>
          event instanceof NavigationStart ||
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
      ),
      switchMap((event) =>
        event instanceof NavigationStart
          ? of(true).pipe(delay(this.DELAY_MS)) // Will be cancelled if navigation ends before the delay
          : of(false)
      )
    ),
    { initialValue: false }
  );
}
